import { Flex } from '@chakra-ui/react';
import { Logo } from '@/components/ui/Logo/Logo';
import { ResetPasswordForm } from './components/ResetPasswordForm/ResetPasswordForm';

export const ResetPasswordPage = () => {
  return (
    <Flex minH="100vh" bg="white" justify="center" align="center" p="5">
      <Flex w="full" maxW="400px" direction="column" align="center">
        <Logo />
        <ResetPasswordForm />
      </Flex>
    </Flex>
  );
};
